import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction } from "react";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { Color } from "../theme/Color";

type SlideInHeaderProps = {
  setVisible?: Dispatch<SetStateAction<boolean>>;
  title: String;
};

const StyledHeaderRow = styled(Row)`
  height: 5rem;
  padding: 1rem;
  color: ${Color.Grey1};
  font-weight: bold;
`;

const SlideInHeader = ({ setVisible, title }: SlideInHeaderProps) => {
  return (
    <StyledHeaderRow middle="xs">
      <Col xs={1}>&nbsp;</Col>
      <Col xs={10}>
        <Row center="xs" middle="xs">
          {title}
        </Row>
      </Col>
      <Col xs={1}>
        <Row end="xs" middle="xs">
          <FontAwesomeIcon
            icon={faClose}
            data-cy="slide-in-close"
            onClick={() => setVisible(false)}
            size="1x"
          />
        </Row>
      </Col>
    </StyledHeaderRow>
  );
};

export default SlideInHeader;
